import { createApi } from '@reduxjs/toolkit/dist/query/react'
import baseQueryWithIam from '../../app/baseQueryWithIam'
import { CoursePackageState, ListResponse, PaginationState } from '../types'

interface getPackagesParams extends PaginationState {
    coursePriceId: number
}

export const coursePackageApi = createApi({
    reducerPath: 'coursePackageApi',
    baseQuery: baseQueryWithIam,
    tagTypes: ['CoursePackage'],
    endpoints: (build) => ({
        getCoursePackagesByCoursePrice: build.query<
            ListResponse<CoursePackageState>,
            getPackagesParams
        >({
            query: ({ coursePriceId, size, page }) => ({
                url: `course-package/discount/${coursePriceId}`,
                params: {
                    size,
                    page,
                },
            }),
            providesTags: (result) =>
                result
                    ? [
                          ...result?.data?.map(({ id }) => ({
                              type: 'CoursePackage' as const,
                              id,
                          })),
                          { type: 'CoursePackage', id: 'LIST' },
                      ]
                    : [{ type: 'CoursePackage', id: 'LIST' }],
            transformResponse: (response: {
                data: ListResponse<CoursePackageState>
            }) => ({
                data: response?.data?.data,
                pageNumber: response?.data?.pageNumber,
                totalCount: response?.data?.totalCount,
                totalPages: response?.data?.totalPages,
            }),
        }),

        createCoursePackage: build.mutation<void, CoursePackageState>({
            query: (coursePackage) => ({
                url: 'course-package/discount',
                method: 'POST',
                body: coursePackage,
            }),
            invalidatesTags: [{ type: 'CoursePackage', id: 'LIST' }],
        }),

        updateCoursePackage: build.mutation<void, CoursePackageState>({
            query: (coursePackage) => ({
                url: `course-package/discount/${coursePackage.id}`,
                method: 'PUT',
                body: coursePackage,
            }),
            invalidatesTags: [{ type: 'CoursePackage', id: 'LIST' }],
        }),

        deleteCoursePackage: build.mutation<void, number>({
            query: (id) => ({
                url: `/course-package/discount/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: (result, error, id) => [
                { type: 'CoursePackage', id },
            ],
        }),
    }),
})
